import { BaseSection } from "components/layout/Section/BaseSection";
import { NsKey } from "enums/NsKey";
import { InputFactory } from "factories/InputFactory";
import { AddressFormFieldNames } from "shared/enums/addressFormFieldNames";
import { useDynamicTranslation } from "hooks/useDynamicTranslation";
import { useCallback } from "react";
import { BankAccountsFieldArray } from "back-office/shared/components/bank-accounts/BankAccountsFieldArray";
import { gestionnaireInputsConfig, GestionnaireInputFieldName } from "./gestionnaireInputsConfig";
import { GestionnaireFormFieldNames } from "./GestionnaireFormFieldNames";

import { GerantSection } from 'back-office/shared/components/gerant/GerantSection';
export const GestionnaireLayout: React.FC = () => {
  const { t } = useDynamicTranslation([NsKey.ActorForm, NsKey.Common]);

  const renderField = useCallback((fieldName: GestionnaireInputFieldName) => {
    return (
      <InputFactory config={gestionnaireInputsConfig} fieldName={fieldName} />
    );
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <BaseSection title={t('ACTOR_FORM.BROKER.SECTIONS.GENERAL_INFO')}>
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2">
            {renderField(GestionnaireFormFieldNames.CompanyName)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.Phone)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.ComplaintEmail)}
          </div>
        </div>
      </BaseSection>

      <BaseSection title={t('ACTOR_FORM.BROKER.SECTIONS.LEGAL_INFO')}>
        <div className="grid grid-cols-3 gap-4">
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.RegistrationNumber)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.Capital)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.RcsCity)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.RcsNumber)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.OriasNumber)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.Rcp)}
          </div>
        </div>
      </BaseSection>

      <BaseSection title="Comptes bancaires">
        <BankAccountsFieldArray
          name={GestionnaireFormFieldNames.BankAccounts}
          emptyLabel="Aucun compte pour l'instant — ils serviront au versement des commissions dans la configuration des tunnels."
          helpText="Le RIB justificatif pourra être joint après la création."
        />
      </BaseSection>

      <BaseSection title={t('COMMON.LABELS.COORDINATE')}>
        <div className="grid grid-cols-6 gap-4">
          <div className="col-span-6">
            {renderField(AddressFormFieldNames.Address)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.AdditionalAddress)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.PostalCode)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.City)}
          </div>
          <div className="col-span-3">
            {renderField(AddressFormFieldNames.Country)}
          </div>
        </div>
      </BaseSection>

      <BaseSection title={t('ACTOR_FORM.BROKER.SECTIONS.USER_INFO')}>
        <div className="grid grid-cols-2 gap-4">
          <div className="col-span-2">
            {renderField(GestionnaireFormFieldNames.PlateformeIds)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.FirstName)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.LastName)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.Email)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.Username)}
          </div>
          <div className="col-span-1">
            {renderField(GestionnaireFormFieldNames.Password)}
          </div>
        </div>
      </BaseSection>

      <GerantSection config={gestionnaireInputsConfig} />
    </div>
  );
};
